import React, { useState, useEffect } from "react";
import { Input, DatePicker, Button, Typography } from "antd";
import styles from "./contractor-submittal.module.css";
import dayjs from "dayjs";
import moment from "moment";

const { Text } = Typography;

function Submittal({
  submittal,
  workingDays,
  nonWorkingDays,
  editSubmittal,
  itemsPendingApprovals,
  onChange,
}) {
  const [data, setData] = useState(submittal);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setData(submittal);
  }, [submittal]);

  const handleChange = (field, value) => {
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setHasChanges(true);
  };

  const handleDateChange = (field, date) => {
    handleChange(field, date ? date.format("MM-DD-YYYY") : "");
  };

  const parseDate = (dateString) => {
    return dateString && dayjs(dateString).isValid() ? dayjs(dateString) : null;
  };

  const formatDisplayDate = (dateString) => {
    const date = parseDate(dateString);
    return date ? date.format("MM-DD-YYYY") : "-";
  };

  const handleSubmit = () => {
    // console.log("Submit for Approval", data);
    editSubmittal(data);
    setHasChanges(false);
  };

  const isDateDisabled = (date, isSubCommittedDeliveryDate) => {
    // Handling Holidays
    const disabledDatesArray = [];
    Object.values(nonWorkingDays).forEach((holiday) => {
      var currDate = moment(holiday["startDate"], "MM/DD/YYYY").startOf("day");
      var lastDate = moment(holiday["finishDate"], "MM/DD/YYYY").startOf("day");
      disabledDatesArray.push(moment(currDate).format("YYYY-MM-DD"));
      while (currDate.add(1, "days").diff(lastDate) < 0) {
        disabledDatesArray.push(moment(currDate).format("YYYY-MM-DD"));
      }
      disabledDatesArray.push(moment(lastDate).format("YYYY-MM-DD"));
    });

    // Function to check if a date is a weekend or a non-working day based on workingDays object
    const isWeekendOrNonWorkingDay = (dateToCheck) => {
      const dayOfWeek = dateToCheck.day();

      // Map dayOfWeek index to workingDays keys
      const dayName = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ][dayOfWeek];

      const isWeekend = [0, 6].includes(dayOfWeek);
      const isNonWorkingDay = workingDays[dayName] === "0";

      return isWeekend || isNonWorkingDay;
    };

    const isFutureDate = (dateToCheck) => dateToCheck.isAfter(moment(), "day");

    if (isSubCommittedDeliveryDate) {
      return (
        date &&
        (disabledDatesArray.includes(date.format("YYYY-MM-DD")) ||
          isWeekendOrNonWorkingDay(date) ||
          isFutureDate(date))
      );
    } else {
      return (
        date &&
        (disabledDatesArray.includes(date.format("YYYY-MM-DD")) ||
          isWeekendOrNonWorkingDay(date))
      );
    }
  };

  useEffect(() => {
    if (hasChanges) {
      onChange && onChange(data);
    }
  }, [hasChanges]);

  return (
    <div className="p-4 d-flex gap-5" style={{ flexWrap: "wrap" }}>
      {/* Left Column */}
      <div style={{ flex: 1, minWidth: 300 }}>
        {/* <div style={{ marginBottom: 16 }}>
          <Text strong>Submittal Title:</Text>
          <div>{data?.specTitle || "-"}</div>
        </div> */}

        <div style={{ marginBottom: 16 }}>
          <Text strong>Submittal Number:</Text>
          <div>{data?.specNumber || "-"}</div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <Text strong>Submittal Revision:</Text>
          <div>{data?.specRevision || "-"}</div>
        </div>

        <div>
          <Text strong>Date Required On Site:</Text>
          <div>{formatDisplayDate(data?.dateRequiredOnSite)}</div>
        </div>
      </div>

      {/* Right Column */}
      <div style={{ flex: 1, minWidth: 300 }}>
        <div style={{ marginBottom: 16 }}>
          <Text strong>Lead Time:</Text>
          {itemsPendingApprovals.includes(data?.entryID) ? (
            // <div>
            //   {data?.leadTime === data?.leadTimeApproval ? (
            //     <>{data?.leadTime || "-"} &rarr; Unmodified</>
            //   ) : (
            //     <>
            //       {data?.leadTime || "-"} &rarr; {data?.leadTimeApproval || "-"}
            //     </>
            //   )}
            // </div>
            <Input
              onKeyDown={(event) => {
                if (
                  !/[0-9]/.test(event.key) &&
                  ![
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                  ].includes(event.key)
                ) {
                  event.preventDefault();
                }
              }}
              value={
                data?.leadTimeApproval === "Unmodified"
                  ? data?.leadTime
                  : data?.leadTimeApproval
              }
              // value={data?.leadTimeApproval}
              disabled
              onChange={(e) => handleChange("leadTime", e.target.value)}
            />
          ) : (
            <Input
              onKeyDown={(event) => {
                if (
                  !/[0-9]/.test(event.key) &&
                  ![
                    "Backspace",
                    "Delete",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                  ].includes(event.key)
                ) {
                  event.preventDefault();
                }
              }}
              value={data?.leadTime}
              onChange={(e) => handleChange("leadTime", e.target.value)}
            />
          )}
        </div>

        <div style={{ marginBottom: 16 }}>
          <Text strong>Sub Committed Delivery Date:</Text>
          {itemsPendingApprovals.includes(data?.entryID) ? (
            // <div>
            //   {data?.subCommittedDeliveryDate ===
            //   data?.subCommittedDeliveryDateApproval ? (
            //     <>{data?.subCommittedDeliveryDate || "-"} &rarr; Unmodified</>
            //   ) : (
            //     <>
            //       {data?.subCommittedDeliveryDate || "-"} &rarr;{" "}
            //       {data?.subCommittedDeliveryDateApproval || "-"}
            //     </>
            //   )}
            // </div>
            <DatePicker
              format="MM-DD-YYYY"
              value={
                data?.subCommittedDeliveryDateApproval === "Unmodified"
                  ? parseDate(data?.subCommittedDeliveryDate)
                  : parseDate(data?.subCommittedDeliveryDateApproval)
              }
              onChange={(date) =>
                handleDateChange("subCommittedDeliveryDate", date)
              }
              disabledDate={(date) => isDateDisabled(date, false)}
              style={{
                width: "100%",
              }}
              className={styles.customDisabledDatepicker}
              placeholder=""
              disabled
            />
          ) : (
            <DatePicker
              format="MM-DD-YYYY"
              value={parseDate(data?.subCommittedDeliveryDate)}
              onChange={(date) =>
                handleDateChange("subCommittedDeliveryDate", date)
              }
              disabledDate={(date) => isDateDisabled(date, false)}
              style={{ width: "100%" }}
              disabled={itemsPendingApprovals.includes(data?.entryID)}
            />
          )}
        </div>

        <div className="w-100 d-flex justify-content-end">
          <Button
            type="primary"
            onClick={handleSubmit}
            disabled={
              !hasChanges || itemsPendingApprovals.includes(data?.entryID)
            }
          >
            {itemsPendingApprovals.includes(data?.entryID)
              ? "Pending Approval"
              : "Submit for Approval"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Submittal;
